import type { ReactNode } from "react";
import { CaretRightIcon } from "@phosphor-icons/react";

// A part of long text that folds (docs/design-system.md §0.6, §0.8; plan M8
// step 8c): a native details element, so Enter and Space toggle it and the
// browser's find-in-page opens it. Folding only changes what shows; what a
// review decision needs never folds, and a review's secondary detail uses
// `More` (§0.3e).

export function Disclosure({ title, count, end, stepNumber, open, onToggle, level = "section", children }: {
  title: ReactNode;
  /** How many items it holds, shown beside the title; useful while it is closed. */
  count?: number;
  /** One short label at the end of the title row, such as the step's tier. */
  end?: ReactNode;
  /** The step's position, separate from its title so wrapped titles stay aligned. */
  stepNumber?: number;
  open: boolean;
  onToggle: (open: boolean) => void;
  /** A section of the text, or one step of it, which sits in a box. */
  level?: "section" | "step";
  children: ReactNode;
}) {
  return <details className={`z-fold is-${level}`} open={open} onToggle={(event) => { const next = event.currentTarget.open; if (next !== open) onToggle(next); }}>
    <summary>
      <CaretRightIcon className="z-fold-caret" size={16} weight="bold" aria-hidden />
      {stepNumber !== undefined && <span className="z-fold-number">{stepNumber}</span>}
      <span className="z-fold-title">{title}</span>
      {count !== undefined && <span className="z-fold-count">{count}</span>}
      {end && <span className="z-fold-end">{end}</span>}
    </summary>
    <div className="z-fold-body">{children}</div>
  </details>;
}
